module.exports = __webpack_public_path__ + "index/img/jiangjia.bf3a3498.png";